module.exports = __webpack_public_path__ + "bw.svg?ddf2a55fbe1465ceb8d99189bfe38881";